import ConfigParameter, { gettext } from "../ConfigParameter";

export default class InstagramUrl extends ConfigParameter {

    constructor() {
        super('instagramUrl', 'text', gettext('Instagram'), 'mainConfig', 'https://instagram.com/_profile_');
    }

}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/InstagramUrl.js